import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="testimonial"
export default class extends Controller {
  static targets = ["excerpt", "full", "button"];
  static values = {
    readMore: String,
    readLess: String,
  };

  connect() {
    this.updateButtonText();
  }

  toggle() {
    const isExpanded = this.fullTarget.classList.contains("hidden");

    if (isExpanded) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  expand() {
    this.excerptTarget.classList.add("hidden");
    this.fullTarget.classList.remove("hidden");
    this.updateButtonText();
  }

  collapse() {
    this.excerptTarget.classList.remove("hidden");
    this.fullTarget.classList.add("hidden");
    this.updateButtonText();
  }

  updateButtonText() {
    const isExpanded = !this.fullTarget.classList.contains("hidden");
    const readMore = this.readMoreValue || "Read more";
    const readLess = this.readLessValue || "Read less";
    this.buttonTarget.textContent = isExpanded ? readLess : readMore;
  }
}
